<template>
    <div class="sustainable-component wage-money-dynamic-salary">

        <!--<div class="bg-success mb-3 p-3 rounded">vue component wage-money-dynamic-salary</div>-->

        <div class="container-fluid p-0">
            <div class="row">
                <div class="col-12">
                    <a href="javascript:void(0)" @click="printDynamicSalary">Visa översikt över de rörliga tilläggens värde</a>
                </div>
            </div>
            <div class="row mt-5">
                <div class="col-12 col-md-6 mr-md-3">
                    <v-select bg-color="white" variant="outlined" label="Faktor" :items="dynamicFactors" v-model="selectedFactor" item-title="FactorName" item-value="DynamicFactorId"></v-select>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-6 mr-md-3">
                    <table class="table table-light table-hover table-striped">
                        <thead class="thead-light">

                            <tr>
                                <th class="col-6">Gradnr.</th>
                                <th class="col-6">Värde kr</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, index) in factorGrades" :key="index">
                                <td>{{row.GradeNumber}}</td>
                                <td>
                                    <v-text-field :decimal-sv="true" v-bind:disabled="disabled" bg-color="white" v-model="row.Salary" hide-details="true" density="compact" variant="outlined"></v-text-field>
                                </td>
                            </tr>
                        </tbody>

                    </table>

                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-6 mr-md-3">
                    <v-btn v-bind:disabled="disabled" size="default" color="primary" class="btn-primary" @click="saveFactorGrades">
                        Skapa värden i lönesystemet
                    </v-btn>
                </div>
            </div>

        </div>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
    </div>
</template>

<script>

    import WageService from "../../Services/WageService";
    import CommonSpinner from '../../common/common-spinner.vue'
    import { getCurrentInstance } from 'vue'

    export default {
        emits: ['updated'],
        name: 'wage-money-dynamic-salary',
        props: {
            model: Object,
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        components: {
            CommonSpinner
        },
        methods: {
            getId() {
                return getCurrentInstance().uid;
            },
            async loadFactors() {
                this.loading++;
                try {
                    this.dynamicFactors = await WageService.getDynamicFactors();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async getDynamicFactorGrades(factorId) {
                this.loading++;
                try {
                    this.factorGrades = await WageService.getDynamicGrades(factorId);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async saveFactorGrades() {
                this.loading++;
                try {
                    await WageService.updateDynamicFactorGrades(this.factorGrades);
                    await WageService.getDynamicFactorGrades(this.selectedFactor);
                    this.displaySnackBar("Sparat");
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                }
                this.loading--;
            },
            async printDynamicSalary() {
                this.newWindow = window.open('/wagesettingsprint/PrintDynamicSalary', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
        },
        data() {
            return {
                dynamicFactors: [],
                selectedFactor: null,
                factorGrades:[],
                internalModel: {
                    JobPositions: [],
                    BlockGrades: [],
                    WageFactorGrades: [],
                    WageFactors: [],
                },
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },
        watch: {
            selectedFactor: function (newVal) {
                this.getDynamicFactorGrades(newVal);
            },
        },
        mounted() {
            this.internalModel = this.model;
            this.loadFactors();
        },

        // eslint-disable-next-line
        setup(props, { emit }) {}

    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
